import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'version'
})
export class VersionPipe implements PipeTransform {

  transform(value: string): string {
      // 1) match the semver part
      const versionMatch = value.match(/\d+\.\d+\.\d+/);
      // 2) match the timestamp part (YYYY-MM-DDtHH-MM-SS)
      const tsMatch = value.match(/(\d{4}-\d{2}-\d{2}t\d{2}-\d{2}-\d{2})/i);

      if (versionMatch && tsMatch) {
        return `${versionMatch[0]}_${tsMatch[1]}`;
      }

      // Fallback: if it doesn’t match, just return the original string
      return value;
    }

}
